<div class="mat-dialog-title">
  <p>BLOQUEIO DE CARTÃO</p>
</div>

<div class="mat-dialog-content">
  <div class="beneficiary-infos">
    <div class="data-container">
      <p class="title">{{ isBeneficiary() ? "Beneficiário" : "Dependente" }}</p>
      <p class="value">{{ getName() }}</p>
    </div>

    <div class="data-container">
      <p class="title">Número do cartão</p>
      <p class="value">{{ getCardNumber() | cardNumberFormat }}</p>
    </div>
  </div>

  <form [formGroup]="formGroup">
    <mat-form-field fxFlex>
      <mat-label>Motivo do bloqueio</mat-label>
      <mat-select formControlName="blockReason">
        <mat-option *ngFor="let reason of blockReasonList" [value]="reason.getName()">{{ reason.getLocalizedName() }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox *ngIf="isBeneficiary()" formControlName="includeDependents">Incluir dependentes no bloqueio?</mat-checkbox>
  </form>
</div>

<div class="mat-dialog-actions">
  <button mat-flat-button class="cancel-btn" (click)="closeDialog()">CANCELAR</button>

  <button mat-flat-button class="block-btn" (click)="blockBeneficiaryCard()">BLOQUEAR</button>
</div>
